import { apiRequest } from '@/shared/api';

export type LeadSourcePhrase = {
  id: string;
  source: string;
  language: string;
  phrase: string;
  enabled: boolean;
  sort_order: number;
  wa_me_url?: string;
  created_at?: string;
  updated_at?: string;
};

export type CreateLeadSourcePhraseInput = {
  source: string;
  language: string;
  phrase: string;
  enabled?: boolean;
  sort_order?: number;
};

export type UpdateLeadSourcePhraseInput = {
  source?: string;
  language?: string;
  phrase?: string;
  enabled?: boolean;
  sort_order?: number;
};

export async function listLeadSourcePhrases(): Promise<LeadSourcePhrase[]> {
  const body = await apiRequest<{ phrases: LeadSourcePhrase[] }>('/crm/sources/phrases');
  return body.phrases ?? [];
}

export async function createLeadSourcePhrase(
  input: CreateLeadSourcePhraseInput,
): Promise<LeadSourcePhrase> {
  return apiRequest<LeadSourcePhrase>('/crm/sources/phrases', {
    method: 'POST',
    body: input,
  });
}

export async function updateLeadSourcePhrase(
  phraseId: string,
  input: UpdateLeadSourcePhraseInput,
): Promise<LeadSourcePhrase> {
  return apiRequest<LeadSourcePhrase>(`/crm/sources/phrases/${encodeURIComponent(phraseId)}`, {
    method: 'PATCH',
    body: input,
  });
}

export async function deleteLeadSourcePhrase(phraseId: string): Promise<void> {
  await apiRequest(`/crm/sources/phrases/${encodeURIComponent(phraseId)}`, {
    method: 'DELETE',
  });
}
